/**
 * @desc 根据最新更新时间推送退货数据到OMS
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(
  params: API.walmart.walmartOrderReturns.pushedToOrderReturnsByUpdateAt.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/walmart/walmartOrderReturns/pushedToOrderReturnsByUpdateAt`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
